// components/PromoCode/DeletePromoModal.js
import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Spinner } from "reactstrap";

const DeletePromoModal = ({ isOpen, toggle, promoCode, onDelete }) => {
  const [deleting, setDeleting] = useState(false);

  const handleDelete = async () => {
    setDeleting(true);
    try {
      await onDelete();
    } catch (error) {
      console.error("Failed to delete promo code:", error);
    } finally {
      setDeleting(false);
    }
  };

  if (!promoCode) return null;

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>Delete Promo Code</ModalHeader>
      <ModalBody>
        <div className="text-center">
          <i className="fas fa-exclamation-triangle fa-3x text-warning mb-3"></i>
          <h5>Are you sure you want to delete this promo code?</h5>

          <div className="mt-3 p-3 border rounded bg-light text-start">
            <div className="mb-2">
              <strong>Name:</strong> {promoCode.name}
            </div>
            <div className="mb-2">
              <strong>Code:</strong> <code>{promoCode.codename}</code>
            </div>
            <div>
              <strong>Type:</strong>{" "}
              {promoCode.freedelivery ? "Free Delivery" : `৳${promoCode.codemoney} Discount`}
            </div>
          </div>

          <div className="alert alert-danger mt-3">
            <i className="fas fa-exclamation-circle me-2"></i>
            This action cannot be undone. All data related to this promo code will be permanently deleted.
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="light" onClick={toggle} disabled={deleting}>
          Cancel
        </Button>
        <Button
          color="danger"
          onClick={handleDelete}
          disabled={deleting}
        >
          {deleting ? (
            <>
              <Spinner size="sm" className="me-2" />
              Deleting...
            </>
          ) : (
            <>
              <i className="fas fa-trash me-2"></i>
              Delete Promo Code
            </>
          )}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default DeletePromoModal;